import React, { useState, useEffect } from "react";
import { Form, Button, Row, Col, Table, Pagination } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../components/Loader";
import Message from "../components/Message";
import { updateUserProfile } from "../actions/userActions";

import { listMyOrders } from "../actions/orderActions";

function ProfileScreen({ history }) {
  const dispatch = useDispatch();
  const userDetails = useSelector((state) => state.userDetails);
  const { error, loading, user } = userDetails;
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const orderListMy = useSelector((state) => state.orderListMy);
  const { loading: loadingOrders, error: errorOrders, orders } = orderListMy;
  const [message] = useState("");

  const initialTaxValue = parseFloat(userInfo.tax).toFixed(2);

  const [currentTaxValue, setCurrentTaxValue] = useState(initialTaxValue);

  const handleTaxChange = (event) => {
    setCurrentTaxValue(event.target.value);
  };
  const taxChanged = currentTaxValue !== initialTaxValue;

  // pagination
  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    if (!userInfo) {
      history.push("/login");
    } else {
      dispatch(listMyOrders());
    }
  }, [dispatch, history, userInfo, user]);

  useEffect(() => {
    if (orders) {
      setTotalPages(Math.ceil(orders.length / itemsPerPage));
    }
  }, [orders]);

  const submitHandler = (e) => {
    e.preventDefault();

    dispatch(
      updateUserProfile({
        id: userInfo._id,
        tax: currentTaxValue,
      })
    );
  };
  return (
    <Row>
      <Col md={3}>
        <h2>Dealer Profile</h2>
        {message && <Message variant="danger">{message}</Message>}
        {error && <Message variant="danger">{error}</Message>}
        {loading && <Loader />}
        <Form>
          <Form.Group>
            <Form.Label>Dealer Logo:</Form.Label>
            <img
              src={
                userInfo.logo
                  ? userInfo.logo
                  : "https://startblue.us-southeast-1.linodeobjects.com/images/logos/logo_holder.png"
              }
              style={{ width: "150px", height: "150px", display: "block" }}
              alt="Dealer Logo"
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>
              Name:{" "}
              <strong>{userInfo.first_name + " " + userInfo.last_name}</strong>
            </Form.Label>
          </Form.Group>
          <Form.Group>
            <Form.Label>
              Email Address: <strong>{userInfo.email}</strong>
            </Form.Label>
          </Form.Group>
          <Form.Group>
            <Form.Label>
              Business Name: <strong>{userInfo.business_name}</strong>
            </Form.Label>

            <Form.Label>
              Address:{" "}
              <strong>
                {userInfo.address +
                  ", " +
                  userInfo.city +
                  ", " +
                  userInfo.state +
                  " " +
                  userInfo.postalCode}
              </strong>
            </Form.Label>

            <Form.Label>
              Phone Number: <strong>{userInfo.phone}</strong>
            </Form.Label>

            <Form.Label>
              Website: <strong>{userInfo.website}</strong>
            </Form.Label>
          </Form.Group>
          <div>
            <br></br>
          </div>{" "}
          <Form.Group>
            <Form.Label>State Tax:</Form.Label>
            <span style={{ display: "flex", flexDirection: "column" }}>
              <Form.Control
                type="number"
                className="input adjust"
                placeholder="Enter state tax"
                value={currentTaxValue} // Use the currentTaxValue as the value
                onChange={handleTaxChange} // Update state on change
                step="0.01"
                min="0"
                max="100"
                required
              />
            </span>
          </Form.Group>
          <br></br>
          <Button
            type="submit"
            className="button std2"
            disabled={!taxChanged}
            onClick={submitHandler}
          >
            Save Changes
          </Button>
        </Form>
        <div>
          <br></br>
          {/* support and FAQ website */}
          <a
            href="https://cloud.lstractorusa.com/s/jMYFqNQAm7T4Fio"
            target="_blank"
          >
            <Button className="button std2">Support & FAQ</Button>
          </a>
          {/* or send us an email */}
          <a href="mailto:it@lstractorusa.com">
            <Button className="button std2">Get Help via Email</Button>
          </a>
        </div>{" "}
      </Col>

      {/* TABLE OF QUOTES */}
      <Col md={9}>
        <h2>Saved Quotes</h2>
        {loadingOrders ? (
          <Loader />
        ) : errorOrders ? (
          <Message variant="danger">{errorOrders}</Message>
        ) : (
          <Table striped responsive className="table table-hover">
            <thead>
              <tr>
                <th>ID</th>
                <th>Date</th>
                <th>Client</th>
                <th>Total</th>
                {/* <th>Status</th> */}

              </tr>
            </thead>

            <tbody>
              {orders
                .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
                .slice(
                  (currentPage - 1) * itemsPerPage,
                  currentPage * itemsPerPage
                )
                .map((order) => (
                  <tr key={order._id}>
                    <td>
                      <LinkContainer
                        style={{
                          fontSize: "1.1rem",
                          fontWeight: "bold",
                        }}
                        to={`/order/${order._id}`}
                      >
                        <a>{order.quote_number}</a>
                      </LinkContainer>
                    </td>
                    <td>{order.createdAt.substring(0, 10)}</td>
                    <td>{order.shippingAddress.first_name}</td>
                    <td>
                      $
                      {parseFloat(order.total_cost)
                        .toFixed(2)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    </td>
                    {/* <td> */}
                      {/* <Form.Control
                        as="select"
                        value={order.status}
                        onChange={(e) => {
                          // dispatch update order
                        }}
                      >
                        <option value="draft">Draft</option>
                        <option value="sent">Sent</option>
                        <option value="in_review">In Review</option>
                        <option value="approved">Approved</option>
                        <option value="rejected">Rejected</option>
                        <option value="cancelled">Cancelled</option>
                        <option value="completed">Completed</option>
                        <option value="expired">Expired</option>
                        <option value="other">Other</option>
                      </Form.Control> */}
{/* 
                      <Form.Group controlId="selection">
                        <Form.Label className="labeldropdown">
                          Choose Option
                        </Form.Label>
                        <Form.Control
                          className="dropdown adjust"
                          as="select"
                          // value={selection}
                          // onChange={(e) => setSelection(e.target.value)}
                          // onChange={handleSelectionChange}
                        >
                          <option value="">-- Select --</option>
                          <option value="markup">Markup</option>
                          <option value="margin">Margin</option>
                        </Form.Control>

                        <hr
                          style={{
                            width: "100%",
                            margin: "1rem 0",
                            marginBottom: "2rem",
                          }}
                        />
                      </Form.Group>
                    </td> */}
                  </tr>
                ))}
            </tbody>
          </Table>
        )}
        <Pagination>
          <Pagination.First
            onClick={() => setCurrentPage(1)}
            disabled={currentPage === 1}
          />
          <Pagination.Prev
            onClick={() => setCurrentPage(currentPage - 1)}
            disabled={currentPage === 1}
          />
          {[...Array(totalPages).keys()].map((page) => (
            <Pagination.Item
              key={page + 1}
              active={page + 1 === currentPage}
              onClick={() => setCurrentPage(page + 1)}
            >
              {page + 1}
            </Pagination.Item>
          ))}
          <Pagination.Next
            onClick={() => setCurrentPage(currentPage + 1)}
            disabled={currentPage === totalPages}
          />
          <Pagination.Last
            onClick={() => setCurrentPage(totalPages)}
            disabled={currentPage === totalPages}
          />
        </Pagination>
      </Col>
    </Row>
  );
}

export default ProfileScreen;
